export default __webpack_public_path__ + "static/media/folder-tender-hammer.1ac3a8e7.svg";